/**
 * ClientBubble: the one look a task's client wears wherever it shows (the
 * My Tasks rows, the Hub rail, the task drawer). A sage-filled pill in
 * the family of the date pills beside it, one step deeper in the ramp
 * (sage-100 against the date pills' sage-50) so it reads as a client, not
 * a date; no border at rest; an underline on hover, since it is a link.
 */

export const CLIENT_BUBBLE_CLASS =
  'rounded-pill bg-sage-100 px-2 py-px font-medium text-sage-700 hover:underline hover:bg-sage-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-400';
